
import React from 'react';
import ProfessionalArchitectureDiagram from './professional-architecture-diagram';

const ArchitectureOverview: React.FC = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <ProfessionalArchitectureDiagram />
    </div>
  );
};

export default ArchitectureOverview;
